import { render } from "./IconThumbDownOutline.vue?vue&type=template&id=303f9ad6"
import script from "./IconThumbDownOutline.vue?vue&type=script&lang=js"
export * from "./IconThumbDownOutline.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__